import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { AppErrorMessageEvent } from '../../../core';

@Component({
  selector: 'error-content',
  templateUrl: './error-modal.component.html',
  styleUrls: ['./error-modal.component.scss']
})
export class ErrorModalComponent {  
  
  static ID = 9011197012343134

  @Input() title: string = "Error(s)"
  
  @Input() errorEvents : AppErrorMessageEvent[] = []
  @Input() errorEvent: AppErrorMessageEvent

  @Output('errorDeleted') errorDeleted$ = new EventEmitter<AppErrorMessageEvent>()

  constructor(public bsModalRef: BsModalRef) {}


  closeModal() {
    this.bsModalRef.hide()
  }
}